<template>
    <div class="container-fluid">
        <div class="row">      
            <Navbar :class="[mobile?'navbar-admin':'navbar-admin-mobile']" v-show="toggle"></Navbar>
            <div  :class="{ 'col-lg-12': !toggle }"  class="col-lg-9 col-md-12 col-xs-12">
              <div class="container">
    
                <Controls></Controls>
               
                <!--
                <Controls2></Controls2>
                -->

                  <!--seccion pasos-->
                  <div class="row">
                      <div class="col-12">
                      <!--
                        
                        QUITAR BUTTON MAXIMIZAR/MINIMIZAR PANEL DE CONTROL

                        <button class="btn btn-default btn-custom-fixed" @click='toggle = !toggle'> 
                          <font-awesome-icon v-show="toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-left']" /> 
                          <font-awesome-icon v-show="!toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-right']" /> 
                        </button>
                      -->
                       <button class="d-xl-none btn btn-default btn-custom-fixed-mobile" @click='mobile = !mobile'> 
                          <font-awesome-icon style="z-index:2;"  :style="{ color: '#FFFFFF', position: 'absolute', left: '3', top: '2' }" size="2x" :icon="['fas', 'bars']" /> 
                        </button>

                        <div class="row mt-5">
                          <div class="col-6">
                            <!--
                           <button class="btn btn-primary">Alojamientos de {{user.nombre}}</button>
                            -->
                          </div>
                          <div class="col-6 text-right">
                            <!--
                            <font-awesome-icon  size="1x" :icon="['fas', 'chevron-right']" /> Agregar alojamiento
                            -->
                          </div>
                        </div>

                        <div v-if="alojamientos" class="row mt-4">
                          <div v-for="alojamiento in alojamientos" :key="alojamiento.idalojamiento" class="col-md-4 mb-2" @show="getPhotos(alojamiento.idalojamiento)">
                            <div class="card" style="width:300px; border:none;">
                                <!-- <h3 v-if="iso639_1 === 'es'">
                                    {{formateaUrl(alojamiento.nombre).es}}
                                </h3>
                                <h3 v-else>
                                   {{formateaUrl(alojamiento.nombre).en}}
                                </h3> -->

                               <a style="text-decoration: none; color:black;" :href="url +'/alojamiento/'+ alojamiento.idalojamiento" target="_blank">
                               <!-- <router-link  :to="'alojamiento/'+alojamiento.idalojamiento"> -->
                               <Carousel :idAlojamiento="alojamiento.idalojamiento"></Carousel>
                               <div>
                                <b-modal :id="'modal-' + alojamiento.idalojamiento" hide-footer title="Compartir alojamiento">
                                  <p class="my-4">Copia este enlace y compártelo con tus amigos:</p>

                                    <p id="textoACopiar" class="my-4">{{url+'/alojamiento/'+alojamiento.idalojamiento}} &nbsp; <button class="btn" style="background-color:transparent"><font-awesome-icon @click="obtieneUrl()" :style="{ color: '#D8D4D4 '}" size="2x" :icon="['fas', 'copy']" /> </button></p>

                                  <p class="my-4">o publícalo en tus redes sociales:</p>
                                  <div class="row">
                                  <div class="col-4">
                                    <center>
                                    <a target="_blank" :href="'whatsapp://send?text='+url+'/alojamiento/'+alojamiento.idalojamiento"><font-awesome-icon :style="{ marginRight: '20px', color: '#25D366'}" size="2x"  :icon="['fab', 'whatsapp']" /></a>
                                    </center>
                                  </div>
                                  <div class="col-4">
                                    <center>
                                    <a target="_blank" :href="'http://www.facebook.com/sharer/sharer.php?u='+url+'/alojamiento/'+alojamiento.idalojamiento"><font-awesome-icon :style="{ marginRight: '20px', color: '#3B5998' }" size="2x"  :icon="['fab', 'facebook-f']" /></a>
                                    </center>
                                  </div>
                                  <div class="col-4">
                                    <center>
                                    <a target="_blank" :href="'https://twitter.com/share?url='+url+'/alojamiento/'+alojamiento.idalojamiento+'&via=houseandflatschile'"><font-awesome-icon :style="{ marginRight: '20px',color: '#00acee' }" size="2x"  :icon="['fab', 'twitter']" /></a>
                                    </center>
                                  </div>
                                  </div>
                                </b-modal>
                              </div>
                               </a>
                               <!-- </router-link> -->
                                <div style="cursor: pointer; box-shadow: 1px 5px 5px 0px rgba(150,150,150,0.63);"  class="card-body">
                                  <div  class="float-right">
                                    <router-link  :to="'/editar-alojamiento/'+alojamiento.idalojamiento">
                                         <img src="../assets/editar.svg">
                                    </router-link>
                                   
                                    &nbsp;
                                    <img @click="clonar(alojamiento.idalojamiento)" src="../assets/copiar.svg">
                                    &nbsp;
                                    <img @click="eliminarAlojamiento(alojamiento.idalojamiento)" src="../assets/borrar.svg">
                                  </div>
                                  <div class="float-left">
                                    <img v-if="alojamiento.alojamiento_idalojamiento" @click="wishList(alojamiento.idalojamiento)" src="../assets/corazonr.svg">
                                    <img v-else @click="wishList(alojamiento.idalojamiento)" src="../assets/favorito.svg">
                                    &nbsp;
                                    <img @click="$bvModal.show('modal-' + alojamiento.idalojamiento)"  src="../assets/compartir.svg">       
                                  </div>
                                </div>
                                <div style="background-color:#F7F7F7; height:10px;">
                                    
                                </div>                                
                               <div style="box-shadow: 1px 2px 5px 0px rgba(150,150,150,0.63);" class="card-body">
                                <h4 v-if="iso639_1 === 'es'" class="card-title">{{JSON.parse(alojamiento.nombre).es}} </h4>
                           
                                <h4 v-else class="card-title">{{JSON.parse(alojamiento.nombre).en}} </h4>                 
                            

                                <div v-if="alojamiento.aprobado === 1">
                                  <div v-b-popover.hover="'Aprobado'" class="circulo"></div>
                                </div>
                                <div v-else-if="alojamiento.aprobado === 2">
                                   <div v-b-popover.hover="'Por aprobar'"  class="circulo-red"></div>
                                </div>
                                <div v-else>
                                  <div v-b-popover.hover="'Por aprobar'"  class="circulo-red"></div>
                                </div>
                                <p class="card-text">${{arriendoexchange(alojamiento.arriendo)}} p/mes</p>
                                
                                <p>{{alojamiento.direccion}}</p>
                              </div>
                              
                            </div>
                            
                          </div>

<!--
                          <div class="col-12">
                              <br>
                              <label class="title-form">Evaluaciones recibidas</label>
                              <br>
                              <textarea  name="message" class="form-control" rows="5" cols="20"></textarea>
                          </div>  
-->
<!--
                          <div class="col-12 mb-4">
                              <br>
                              <label class="title-form">Evaluaciones pendientes</label>
                              <br>
                              <textarea  name="message" class="form-control" rows="5" cols="20"></textarea>
                          </div>  
                         --> 
                        </div>
                        <div v-else>
                          <div v-if="iso639_1 === 'es'">
                          <h4>Aún no tienes alojamientos con nosotros sube el tuyo haciendo click 
                          <router-link  to="/registro-alojamiento">                     
                              aquí
                          </router-link>   
                          </h4>
                          <br>
                          <h4>No eres anfitrión? 
                          <a :href="url+'/explore'" target="_blank">Buscar propiedades</a>
                          </h4> 
                          </div>
                          <div v-else>
                          <h4>You don't have accommodation with us yet, upload yours by clicking 
                          <router-link  to="/registro-alojamiento">                     
                              here
                          </router-link>   
                          </h4>
                          <br>
                          <h4>You are not a host?
                          <a :href="url+'/explore'" target="_blank">Search properties</a>
                          </h4> 
                          </div>
                        </div>



                        <div v-show="loader" style="background-color:white;" class="container loader text-center">
                            <div class="row">
                                <div class="col-12">
                                <img style="width:40%" class="img-fluid" src="../assets/logo.png">
                                </div>
                                <div class="col-12 gif">
                                <img src="../assets/load.gif">
                                <p class="title-sub-2 text-center">Estamos procesando su información</p>
                                </div>
                            </div>
                        </div>   

                      </div>
                  </div>
                  <!--fin seccion inputs-->
              </div>
            </div>
        </div>    
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import Navbar from '@/components/Navbar.vue'
import Controls from '@/components/Controls.vue'
import Controls2 from '@/components/Controls2.vue'
import Carousel from '@/components/Carousel.vue'


export default {
  name: 'Dashboard', 
  components: {
    Navbar,
    Controls,
    Controls2,
    Carousel
  },
  data() {
    return {
     toggle: true,
     mobile : true,
     url : process.env.VUE_APP_SHARE_URL
    }
  },
  methods:{
    ...mapActions(['getAlojamientos', 'eliminarAlojamiento', 'wishList', 'clonar']),
     arriendoexchange (arriendo) {
       let arriendoexchange = 0
        if(this.user.moneda){
          console.log(this.user.moneda)
          arriendoexchange = Number(arriendo) / Number(this.user.moneda)
          arriendoexchange = arriendoexchange.toFixed(2).split('.');
          arriendoexchange[0] = arriendoexchange[0].split(/(?=(?:...)*$)/).join('.');
          arriendoexchange = arriendoexchange.join(',')
        }else{
          arriendoexchange = Number(arriendo)
          arriendoexchange = arriendoexchange.toFixed(2).split('.');
          arriendoexchange[0] = arriendoexchange[0].split(/(?=(?:...)*$)/).join('.');
          arriendoexchange = arriendoexchange.join(',')
        }
        return arriendoexchange; 
     },
     obtieneUrl(){
        var codigoACopiar = document.getElementById('textoACopiar'); 
        //Debe estar seleccionado en la página para que surta efecto, así que...
        var seleccion = document.createRange(); //Creo una nueva selección vacía
        seleccion.selectNodeContents(codigoACopiar);    //incluyo el nodo en la selección
        //Antes de añadir el intervalo de selección a la selección actual, elimino otros que pudieran existir (sino no funciona en Edge)
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(seleccion);  //Y la añado a lo seleccionado actualmente
        var res = document.execCommand('copy');
        window.getSelection().removeRange(seleccion);
     },
     formateaUrl(value){
       let url = ''
       return JSON.parse(url = value.split(' ').join('-')); 
     }     
  },
  computed:{
    ...mapState(['alojamientos', 'user', 'language', 'iso639_1', 'loader', 'heart'])     
  },   
  created(){    
    this.getAlojamientos()
  }
}
</script>


<style scoped>
.dot {
  height: 25px;
  width: 25px;
   background-color: #F7F7F7;
  border-radius: 50%;
  display: inline-block;
  border: 1px;
  color: #5A287F;
  border-style: solid;
  border-width: 1px;
  border-color:#5A287F;
}

.opt-active{
  background-color: #5A287F;
  color: #FFFFFF;
  border-radius: 0;
}

.total{
  background-color: #5A287F;
  position: absolute;
  top:150px;
  width: auto;
}

.card-footer{
    background-color: #5A287F;
    color:white;
}

.recibe{
    background-color: #5A287F;
    color:white;
}

.circulo {
     width: 20px;
     height: 20px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: #A2C037;
}

.circulo-red {
     width: 20px;
     height: 20px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: #FF5353;
}

.loader{
  position:absolute; 
  top:25%; 
  left:-10%; 
  z-index:500;
}


  @media (max-width: 768px) {
  .loader {
      position:absolute; 
      top:40%; 
      left:0%; 
      z-index:500;
      margin-bottom: 20px;
    }
  }

  .gif{
    top:-120px;    
  }

  @media (max-width: 768px) {
  .gif {
     top:0px; 
    }
  }
</style>


